import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { popupActions } from '../../store/popupStore';
import { layoutActions } from '../../store/layoutStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { links, createPanelItem } from '../layoutItems/links';

import './footer.scss';

class MobileFooter extends React.Component {
    render() {
        return (
        <div className="mobile-footer print-hidden">
            {links.map(i => createPanelItem(i))}
            {links.slice(4).map(x => x.canShow()).length >= 1 &&
                <div className="more panel-item" onClick={() => this.props.toggleMoreItems()}>
                    <div className="icon-holder">
                        <div className="icon-wrap">
                            <FontAwesomeIcon className="svg-standard-color" icon="ellipsis-v" />
                        </div>
                        <span className="icon-short-description"><Translate id="Report.Common.More" /></span>
                    </div>
                </div>
            }
        </div>
        );
    }
}

export default connect(
    state => ({ user: state.userContext }),
    dispatch => bindActionCreators(Object.assign({}, popupActions, layoutActions), dispatch)
)(MobileFooter);